// extracted by mini-css-extract-plugin
export default {"nav":"NewNavbar_nav__csJaO","logoCont":"NewNavbar_logoCont__LKA8W","DD":"NewNavbar_DD__JHcWc"};